  <template>
  <div class="">

    <div class="label-standard mb-2">Ownership</div>

    <!-- 
      Each asset/liability will have the list of applicants and how much each person
      owns that asset/liability. Even if someone owns 0, they will be displayed.
      We need to display the applicants in the order of applicants listed within
      Client object. So we need to loop through $store.state.client.applicants.
      But the ownership information is actually in each asset/liability->applicants information
      So we are looping through two arrays, match the applicant ID, display their name
      and then display how much each owns.
    -->
    <template v-for="(applicant, applicantIndex) in $store.state[$store.state.view + 'Module'].client.applicants">
      <template v-for="(ownership, ownershipIndex) in applicants">
        <template v-if="ownership.applicant_id == applicant.id">
          <div class="relative mt-2">
            <div class="overflow-hidden" style="position:absolute;left:10px;top:10px;">
              <div class="float-left">
                <input 
                  type="checkbox" 
                  :id="'input-ownership-' + localObject.id + '-' + ownershipIndex"
                  :checked="ownership.value > 0 ? true : false"
                  v-on:change="ownershipChanged(ownershipIndex, $event.target)" />                    
              </div>

              <div class="float-left" style="margin:0 0 0 10px;">
                <label class="text-sm" :for="'input-ownership-' + localObject.id + '-' + ownershipIndex">
                  {{ getApplicantName(applicant) }}
                </label>
              </div>
            </div>

            <input type="text" 
              class="text-right w-full text-sm border border-gray-600"
              style="padding:10px 30px 10px 10px;"
              :disabled="ownership.value == null || ownership.value == 0"
              :ref="'inputValue' + ownershipIndex"
              v-bind:value="ownership.value"
              v-on:keyup="valueTyped(ownership, ownershipIndex, $event.target.value)"
              v-on:blur="valueChanged(ownershipIndex, $event.target.value)" />
            <div style="position: absolute;top:10px;right:10px;" class="text-gray-900 text-sm">%</div>
          </div>
        </template>
      </template>
    </template>

    <div class="text-red-500 px-4 pb-4 mt-1" v-if="error != null">{{ error }}</div>
  </div>  
</template>

<script>
  import axios        from 'axios'
  import { EventBus } from '@/shared/event-bus'

  export default {

    // REMEMBER - ownership component can be used for both
    // asset or liability, so we can have either prop
    props : {
      asset : {
        type : Object,
        required : false
      },

      liability : {
        type : Object,
        required : false
      }
    },

    data() {
      return {

        // let's copy the asset or liabiloty object
        // so we can change its values via v-model binding
        localObject: this.asset != null ? this.asset : (this.liability != null ? this.liability : null),
        applicants : this.asset != null ? this.asset.asset_applicants : (this.liability != null ? this.liability.liability_applicants : null),
        error      : null
        // error1 : ''
      }
    },

    methods : {

      ownershipChanged(index, target) {

        // let applicants = this.asset != null ? this.localObject.asset_applicants : (this.liability != null ? this.localObject.liability_applicants : null)

        // Work out how many people have values more than 0 - skip the index
        let howManyOwns = 0
        for(let i=0; i < this.applicants.length; i++) {
          if(i != index && this.applicants[i].value > 0) {
            howManyOwns++
          }
        }

        // if target is checked, then we plus one
        if(target.checked) {
          howManyOwns++
        }

        this.error = howManyOwns == 0 ? "Please select at least one owner" : null

        // now we simply divide 100 by howManyOwns
        let ownershipPercentage = parseInt(100 / howManyOwns)
        for(let i=0; i < this.applicants.length; i++) {
          
          if(i == index) {
            if(target.checked) {
              this.applicants[i].value = ownershipPercentage
            } else {
              this.applicants[i].value = 0
            }            
          }

          // when we re-assign values, we only assign to those who already have
          // ownership
          else if(this.applicants[i].value > 0) {
            this.applicants[i].value = ownershipPercentage
          }
        }

        // focus and highlight
        // this.$refs['inputValue' + index][0].focus()

        // now that we have ownership updated, let's make a server request and save it
        // things work similarly to the update value method, but we are going to just
        // send the whole applicants array to handle it in the backend
        // we also have to make sure that the auto saving is flashing

        // send an event to show auto saving
        this.save()
      },

      valueTyped(ownership, index, value) {
        // check if the value typed makes the overall value above 100, then print error
        // message and turn the value back to previous
        let total = parseFloat(value);
        for(let i=0; i < this.applicants.length; i++) {
          if(i != index && this.applicants[i].value > 0) {
            total += parseFloat(this.applicants[i].value)
          }
        }

        if(total > 100) {
          this.$refs['inputValue' + index][0].value = this.applicants[index].value
          // this.errors[index] = 'hello'
        } else {

        }
      },

      valueChanged(index, value) {
        this.applicants[index].value = parseFloat(value)
        this.save()
      },

      save() {
        EventBus.$emit('set-autosave', true)
        let assetOrLiability = this.asset != null ? 'asset' : 'liability'
        this.apiPost({
          clientId : this.$route.params.clientId,
          objectId : this.localObject.id,
          ownership: this.applicants          
        }, assetOrLiability + '/edit-ownership', () => {
          EventBus.$emit('set-autosave', false)
        })
      }
    }
  }
</script>